module.exports = __webpack_public_path__ + "static/img/3设计师2.0e29ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/3设计师2.png
// module id = 5LrS
// module chunks = 1